import clipArtApi from "@/api/clip-art";
import storageApi from "@/api/storage";
import {
  ClipArt,
  UploadManyClipArts,
  UploadOneClipArt,
} from "@/interfaces/clip-art.interface";
import pLimit from "p-limit";
import { v4 } from "uuid";
import { getFileNameWithoutExt, naturalSortFileList } from "./common";

const BASE_PATH = "library/clip-arts";
const CONCURRENCY = 2;

export const uploadManyClipArts = async (
  clipArtFiles: File[],
  categoryId?: string,
  onProgress?: (data: string) => void,
) => {
  const files = naturalSortFileList(clipArtFiles, "image");
  const items: UploadOneClipArt[] = [];
  const limiter = pLimit(CONCURRENCY);
  const uploadProcesses: Promise<string | undefined>[] = [];
  const successfulUploads: UploadOneClipArt[] = [];

  let progress = 0;
  onProgress?.(`(${progress}/${files.length})`);
  files.forEach((file) => {
    const [, ext] = file.type.split("/");
    const filePath = BASE_PATH;
    const fileName = `${v4()}.${ext}`;
    const data = {
      name: getFileNameWithoutExt(file.name),
      s3Path: `${filePath}/${fileName}`,
      relativePath: file.webkitRelativePath,
    };
    items.push(data);
    uploadProcesses.push(
      limiter(() =>
        storageApi
          .uploadFile(file, filePath, fileName, file.type)
          .then((url) => {
            if (url) {
              progress += 1;
              onProgress?.(`(${progress}/${files.length})`);
              successfulUploads.push(data);
            }
            return url;
          }),
      ),
    );
  });

  await Promise.all(uploadProcesses);

  const payload: UploadManyClipArts = { categoryId, items };
  try {
    await clipArtApi.uploadMany(payload);
    return successfulUploads;
  } catch (error) {
    console.log(error);
    return successfulUploads;
  }
};

export const uploadClipArtImage = async (clipArt: ClipArt, file: File) => {
  try {
    const [type, ext] = file.type.split("/");
    if (type !== "image") return;
    const filePath = `${BASE_PATH}`;
    const fileName = `${v4()}.${ext}`;
    await storageApi.uploadFile(file, filePath, fileName, file.type);
    const imagePath = `${filePath}/${fileName}`;
    await clipArtApi.updateOneById(clipArt._id, { path: imagePath });
    return imagePath;
  } catch (error) {
    console.error(error);
  }
};

export const uploadClipArtThumbnail = async (clipArt: ClipArt, file: File) => {
  try {
    const [type, ext] = file.type.split("/");
    if (type !== "image") return;
    const filePath = `${BASE_PATH}/thumbnail`;
    const fileName = `${v4()}.${ext}`;
    await storageApi.uploadFile(file, filePath, fileName, file.type);
    const thumbnailPath = `${filePath}/${fileName}`;
    await clipArtApi.updateOneById(clipArt._id, { thumbnailPath });
    return thumbnailPath;
  } catch (error) {
    console.error(error);
  }
};
